interface OfferSummaryPriceDisplayInput {
  dealReferencePrice: string | null;
  priceHistoryAverage: string | null;
  priceHistoryMax: string | null;
  priceHistoryMin: string | null;
  priceIndicators: string[];
  priceInsightsVisible?: boolean;
}

/** Keeps the current offer price public while exposing derived insights only when allowed. */
export function offerSummaryPriceDisplay<T extends OfferSummaryPriceDisplayInput>(offer: T) {
  if (offer.priceInsightsVisible !== true) {
    return {
      averagePrice: null,
      dealReferencePrice: null,
      highestPrice: null,
      lowestPrice: null,
      movementSource: {},
      priceIndicators: [],
      priceInsightsVisible: false,
    };
  }

  return {
    averagePrice: offer.priceHistoryAverage,
    dealReferencePrice: offer.dealReferencePrice,
    highestPrice: offer.priceHistoryMax,
    lowestPrice: offer.priceHistoryMin,
    movementSource: offer,
    priceIndicators: offer.priceIndicators,
    priceInsightsVisible: true,
  };
}
